import { render, staticRenderFns } from "./DealPropertyList.vue?vue&type=template&id=0968f23f&scoped=true&"
import script from "./DealPropertyList.vue?vue&type=script&lang=js&"
export * from "./DealPropertyList.vue?vue&type=script&lang=js&"
import style0 from "./DealPropertyList.vue?vue&type=style&index=0&id=0968f23f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0968f23f",
  null
  
)

export default component.exports